import { getPhoneNumber } from './common.js'
export default {
  init() {
		jQuery('.cmp_sales').slick({
		  infinite: false,
		  slidesToShow: 1,
		  speed:1000,
		  draggable: false,
		  slidesToScroll: 1,
		  rtl: true,
		  arrows:true,
		  dots:true,
      autoplay: true,
      autoplaySpeed: 3000,
		  responsive: [
		    {
		      breakpoint: 649,
		      settings: {
		      	infinite: true,
		        slidesToShow: 1,
		        fade:true,
		        slidesToScroll: 1,
		        arrows:false,
		      }
		    },
		  ]
		});

    function detectMobile()
    {
      const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
      ];

      return toMatch.some(function (toMatchItem) {
        return navigator.userAgent.match(toMatchItem);
      });
    }

		if (detectMobile()) {
      var titleH2 = jQuery('.full_promotions_screen .contact_sales.site-row h2').clone();
      jQuery('.full_promotions_screen .contact_sales.site-row h2').remove();
      jQuery('.full_promotions_screen .contact_sales.site-row .site-content .contact-us-container form p:last-of-type').prepend(titleH2);
    }

    window.addEventListener('load', (event) => {
      var phoneNumber = getPhoneNumber();
      if(phoneNumber)
        $(`.telephone_cta`).prop('href', "tel:"+phoneNumber);
    });

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/promotions.js